module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage3-desktop.jpg?v=65200b75";